import React from "react";
import PropTypes from "prop-types";
import { InputNumber, Card, Descriptions as List } from "antd";
import { PermissionContextManager } from "hocs/permission-context-manager";
import { formatCurrency } from "utilities/currency";
import { UI_PERMISSIONS } from "constants";

const ListItem = List.Item;

const ProposedLimit = props =>
    props.editable ? (
        <InputNumber
            value={props.value}
            onChange={props.onChange}
            onBlur={props.onBlur}
            size={"small"}
            style={{
                width: "100%"
            }}
        />
    ) : (
        formatCurrency(parseInt(+props.value), true)
    );

ProposedLimit.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    editable: PropTypes.bool
};

class SupplyChainProposedLimit extends React.Component {
    onChange = value => {
        this.value = value;
        this.forceUpdate();
    };
    submitValue = () => this.props.update(this.value);
    getCardActions = () =>
        this.props.SUPPLY_CHAIN_EDIT && this.props.isUserAllowedToEdit && !this.props.recreditViewOnlyPermission
            ? [
                <a key={"proposed-limit"} onClick={this.submitValue}>
                      Update Proposed Limit
                </a>
            ]
            : [];
    render() {
        const { data } = this.props;
        if (!data) {
            return null;
        }
        if (!this.value) {
            this.value = this.props.proposedLimit;
        }
        return (
            <Card
                title={"Limit Details"}
                className={"padless-card"}
                extra={this.getCardActions()}>
                <List bordered size={"middle"} column={1}>
                    {data &&
                        data
                            .filter((_, key) => key !== "proposed_limit")
                            .map(_ => (
                                <ListItem key={_.label} label={_.label}>
                                    {formatCurrency(_.value)}
                                </ListItem>
                            ))
                            .toList()
                            .toArray()}
                    {data && (
                        <ListItem label={"Proposed Limit"}>
                            <ProposedLimit
                                onChange={this.onChange}
                                value={this.value}
                                editable={this.props.SUPPLY_CHAIN_EDIT && this.props.isUserAllowedToEdit}
                            />
                        </ListItem>
                    )}
                </List>
            </Card>
        );
    }
}

SupplyChainProposedLimit.propTypes = {
    data: PropTypes.object,
    proposedLimit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    update: PropTypes.func,
    SUPPLY_CHAIN_EDIT: PropTypes.bool,
    isUserAllowedToEdit: PropTypes.bool,
    recreditViewOnlyPermission: PropTypes.bool,
};

export default PermissionContextManager({
    permission: UI_PERMISSIONS.SUPPLY_CHAIN_VIEW,
    propsPermissions: {
        SUPPLY_CHAIN_EDIT: UI_PERMISSIONS.SUPPLY_CHAIN_EDIT
    }
})(SupplyChainProposedLimit);
